import type { DeniedMessage } from '../types.js';

/** «توقف» pressed during the analysis: nothing answered, nothing charged. */
export function StoppedNote() {
  return (
    <div className="sk-card ai-state ai-note" role="status">
      تحلیل متوقف شد؛ توکنی کسر نشد.
    </div>
  );
}

/**
 * Safety net for frames K / L as a message. The workspace is replaced by
 * `WorkspaceBlocked` in these states, so the composer cannot send; this only
 * renders if a send somehow reaches the preflight anyway.
 */
export function DeniedNote({ message }: { message: DeniedMessage }) {
  return (
    <div className="sk-card ai-state ai-note" role="alert">
      {message.reason === 'suspended'
        ? 'دسترسی سازمان معلق است؛ دستیار در این مدت پرسش نمی‌پذیرد.'
        : 'به دستیار هوشمند دسترسی ندارید.'}
    </div>
  );
}
